import { Pipe, PipeTransform } from '@angular/core';

import moment_ from 'moment-timezone';
const moment = moment_;

import * as _ from 'lodash';
@Pipe({
    name: 'momentDate'
})
export class MomentDatePipe implements PipeTransform {
    // Takes in a string date and converts it to date, using format e.g. 'LLLL', or relative time e.g. 'yesterday'
    transform(input: string, format = 'relative'): any {
        let newValue = null;

        /** moment supports specifying calendar output formats per invocation */
        moment().calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'dddd',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: 'LL'
        });

        if (input && input.length === 5) {
            const hourAsNumber = parseInt(input.substring(0, 2));
            const minutesAsNumber = parseInt(input.substring(3, 5));
            newValue = moment().hour(hourAsNumber).minutes(minutesAsNumber);
        } else {
            newValue = moment(input);
        }

        if (format === 'relative') {
            return newValue.calendar();
        }
        return newValue.format(format);
    }
}
